<template>
  <div v-if="value" class="readonly-text-field">
    <fields-group :label="label">
      <div class="readonly-text-field_text">
        {{ value }}
      </div>
    </fields-group>
  </div>
</template>

<script>
  import FieldsGroup from '@/components/ui/FieldsGroup.vue'

  export default {
    name: 'ReadOnlyTextField',
    components: { FieldsGroup },
    props: {
      label: {
        type: String,
        default: 'Категории',
      },
      value: {
        type: [String, Number, Boolean, Object, Array],
        default: null,
      },
    },
    data () {
      return {
      }
    },
  }
</script>

<style lang="less" scoped>
  .readonly-text-field {
    color: #000;
    &_text {
      font-size: 14px;
      //color: #000;
    }
  }
</style>
